/**
 * Copyright © 2026 Adnuntius AS.
 */

/**
 * Run copy-modal success handling on the next macrotask so $state.go / toasts
 * do not race modal teardown change detection (NG0100 on destination pages).
 */
export function handleCopyModalResult(apply: () => void): void {
  setTimeout(apply);
}
